<template>
    <b-overlay :show="loading" rounded="sm">
        <div class="d-flex flex-column flex-sm-row justify-content-between mb-3">
            <div class="d-flex gap-2 align-items-top h5">
                <div class="">Comentário Geral</div>
                <span v-b-tooltip.hover title="Aqui você insere um comentário geral sobre o texto do aluno">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icons" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                    </svg>
                </span>
            </div>
            <div v-if="canEdit"  role="button" class="text-primary" @click="openObservations" :disabled="loadingObservations">
                <svg height="18px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                </svg>
                <span class="fw-normal">Aplicar Modelo de Comentário Geral</span>
            </div>
        </div>


        <b-card v-if="essay" class="mb-3">

            <div v-if="!canEdit">

                <div class="ql-snow" v-if="form.observations">
                    <div class="ql-editor" v-html="form.observations"></div>
                </div>

                <div class="text-muted" v-else>
                    Não há comentário para essa redação.
                </div>

            </div>

            <b-form v-if="canEdit" @submit="submit" @submit.stop.prevent>

                <!-- Field -->
                <b-form-group>

                    <b-textarea
                        v-if="!commentFull"
                        placeholder="Aqui você insere um comentário geral sobre o texto do aluno ..."
                        rows="4"
                        v-model="form.observations">
                    </b-textarea>

                    <div class="mb-3" v-if="commentFull">



                        <b-modal
                            id="modalObservations"
                            title="Modelos de Comentários"
                            centered
                            hide-footer>

                            <b-form-group
                                label="Atalho / Gatilho do Comentário Geral"
                                description="Esses atalhos você pode cadastrar no menu de pré-comentários">

                                <b-form-input
                                    type="text"
                                    v-model="formObservations.text"
                                    placeholder="Faça a busca do gatilho ..."
                                    :disabled="loadingObservations"
                                    debounce="500">
                                </b-form-input>

                            </b-form-group>

                            <b-table
                                empty-text="Não encontramos nenhum resultado na busca :( Caso não tenha cadastrado nenhum modelo de comentário, vá ao menu Pré-Comentários > Comentários Gerais"
                                :fields="fieldsObservations"
                                :items="observations">

                                <template v-slot:cell(name)="row">
                                    <span class="font-weight-bold">
                                        {{ row.item.name }}
                                    </span>
                                </template>

                                <template v-slot:cell(char)="row">

                                    <b-button type="button" size="sm" variant="outline-info" @click="showContent(row.item)">
                                        Ver Conteúdo
                                    </b-button>

                                </template>

                                <template v-slot:cell(actions)="row">
                                    <div class="text-right">
                                        <!-- Details -->
                                        <a href="javascript:void(1);" @click="applyObservation(row.item)" v-b-tooltip.hover title="Aplicar Modelo">
                                            <i class="fas fa-check mr-1"></i> Aplicar Modelo
                                        </a>
                                    </div>
                                </template>

                            </b-table>
                        </b-modal>
                    </div>

                    <!-- Input -->
                    <quill-editor
                        v-if="commentFull"
                        ref="myQuillEditor"
                        v-model="form.observations"
                        :options="editorOption">

                    </quill-editor>

                    <!-- Error -->
                    <has-errors :errors="errors" name="observations" />
                </b-form-group>

                <!-- Submit -->
                <b-button type="submit" variant="primary" :disable="loading">
                    Salvar Comentário
                </b-button>
            </b-form>
        </b-card>

        <b-modal id="modalPreview" title="Prévia do Conteúdo" size="lg" hide-footer>
            <div class="ql-snow" v-if="charObservation">
                <div class="ql-editor" v-html="charObservation"></div>
            </div>
        </b-modal>

    </b-overlay>
</template>

<script>
// Editor
import {quillEditor} from 'vue-quill-editor'

export default {
    components: {
        quillEditor
    },
    props: ['essay', 'commentFull'],
    data() {
        return {
            loading: false,
            loadingObservations: false,
            form: {
                observations: this.essay.observations
            },
            formObservations: {
                text: null
            },
            charObservation: null,
            canEdit: true,
            errors: {},
            fieldsObservations: [
                { key: 'name', label: 'Gatilho / Atalho'},
                { key: 'char', label: 'Prévia do Conteúdo'},
                { key: 'actions', label: ''},
            ],
            editorOption: {
                placeholder: 'Aqui você insere um comentário geral sobre o texto do aluno ...',
                modules: {
                    toolbar: [
                        [{ 'size': ['small', false, 'large', 'huge'] }],

                        ['bold', 'italic', 'underline', 'strike'],
                        ['clean', {'align': [] },'blockquote'],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        [{ 'color': [] }, { 'background': [] },'link'],

                    ],
                }
            },
            observations: []
        }
    },
    watch: {
        'formObservations.text': async function (value) {
            await this.loadObservations(value);
        }
    },
    created() {

        if (this.essay.status === 'OKAY' || this.essay.status === 'WAIT' || this.essay.status === 'BLOCK'){
            this.canEdit = false;
        }

    },
    methods: {

        submit() {
            this.loading = true;
            axios.put('/teacher/essays/' + this.essay.id + '/observations', this.form)
                .then((result) => {
                    const response = result.data.data;

                    // Save Message
                    this.$toast.success('O comentário geral foi salvo :)', {
                        duration: 1500
                    })

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

        async openObservations() {
            await this.loadObservations('');
            await this.$bvModal.show('modalObservations');
        },

        async loadObservations(text) {
            this.loadingObservations = true;
            await axios.get('/teacher/pre-observations/search', {
                params: {
                    text: text
                }
            })
                .then((result) => {
                    this.observations = result.data;
                })
                .finally(() => this.loadingObservations = false)

        },

        async showContent(item) {
            this.charObservation = item.char;
            await this.$bvModal.show('modalPreview');
        },

        applyObservation(item) {
            this.$bvModal.msgBoxConfirm('Deseja realmente aplicar este modelo na redação atual ? Atenção que ao aplicar será removido qualquer conteúdo que já tenha digitado para substituição do modelo escolhido.', {
                cancelTitle: 'Cancelar',
                okTitle: 'Sim, Quero aplicar',
                cancelVariant: 'default',
                okVariant: 'primary'
            }).then(answer => {
                if (answer) {
                    this.form.observations = item.char;
                    this.$bvModal.hide('modalPreview');
                    this.$bvModal.hide('modalObservations');
                }
            })
        }

    }
}
</script>

<style>
.quill-editor .ql-toolbar.ql-snow,
.ql-container{
    border: none !important;

}
.ql-snow.ql-toolbar .ql-picker.ql-size{
    background-color: transparent;
}
.ql-snow.ql-toolbar .ql-picker.ql-size .ql-picker-label{
    border: 1px solid #80808059;
    display: flex;
    align-items: center;

}
.ql-snow.ql-toolbar .ql-formats >  button,
.ql-snow.ql-toolbar .ql-formats >  span{
    height: 30px;
    padding: 2px;
    border-radius: 5px;
    margin: 0 4px;
    background-color: rgba(128, 128, 128, 0.137);
    display: flex;
    align-items: center;
    justify-content: center;
}
.ql-snow.ql-toolbar .ql-formats svg{
    height: 18px;

}

</style>

<style scoped>
    .icons{
        height: 20px;
    }


</style>
